const SectionCategoriesTag = ({ props, listeners }) => {
    const { category, activeCategories } = props;

    const hasActiveCategories = !!activeCategories?.length;
    const isAllCategory = category.id === 'all';
    const isActive = hasActiveCategories
        ? !!activeCategories.find(id => id === category.id)
        : isAllCategory;

    const toggleActive = () => {
        if (!isAllCategory || !isActive) {
            listeners['toggle-active']({
                category,
                isActive: !isActive,
            });
        }
    };

    return (
        <div
        class={[
            'l-ss-c-section-categories-tag',
            { 'l-ss-c-section-categories-tag-active': isActive },
        ]}
        onClick={toggleActive}>
            <span>{category.name}</span>
            {category.hits && <strong>{category.hits}</strong>}
        </div>
    );
};

SectionCategoriesTag.props = {
    category: {
        type: Object,
        required: true,
    },
    activeCategories: {
        type: Array,
    },
};

export default SectionCategoriesTag;